module.exports = __webpack_public_path__ + "img/6_153.2ab33354.png";